'use client';

import React from 'react';

export type MicrophonePermissionState = {
  denied: boolean;
  setDenied: (value: boolean) => void;
};

const noop = () => undefined;

const defaultValue: MicrophonePermissionState = {
  denied: false,
  setDenied: noop,
};

export const MicrophonePermissionContext =
  React.createContext<MicrophonePermissionState>(defaultValue);

export function MicrophonePermissionProvider({
  value,
  children,
}: React.PropsWithChildren<{ value: MicrophonePermissionState }>) {
  return (
    <MicrophonePermissionContext.Provider value={value}>
      {children}
    </MicrophonePermissionContext.Provider>
  );
}

export function useMicrophonePermission() {
  return React.useContext(MicrophonePermissionContext);
}

export function MicrophonePermissionEffects() {
  const { denied } = useMicrophonePermission();

  React.useEffect(() => {
    if (denied) {
      console.warn('Microphone permission was denied');
    }
  }, [denied]);

  return null;
}
